document.addEventListener('DOMContentLoaded', function() {
  let heroBanner = document.querySelector('.banner_slider_slider');
  if(heroBanner) {
    var swiper = new Swiper('.banner_slider_slider', {
    	pagination: {
    		el: '.swiper-pagination',
    		clickable: true
    	},
    	autoplay: {
        delay: 4000,
    		disableOnInteraction: false
      },
    	loop: true,
    	watchSlidesProgress: true,
        effect: 'fade',
    });
    
    document.addEventListener('mouseenter', event => {
    	const el = event.target;
    	if (el && el.matches && el.matches('.banner_slider_slider')) {
    		el.swiper.autoplay.stop();
    		el.classList.add('swiper-paused');
    		
    		const activeNavItem = el.querySelector('.swiper-pagination-bullet-active');
    		activeNavItem.style.animationPlayState="paused";
    	}
    }, true);
    
    document.addEventListener('mouseleave', event => {
    	const el = event.target;
    	if (el && el.matches && el.matches('.banner_slider_slider')) {
    		el.swiper.autoplay.start();
    		el.classList.remove('swiper-paused');
    
    		const activeNavItem = el.querySelector('.swiper-pagination-bullet-active');
    		
    		activeNavItem.classList.remove('swiper-pagination-bullet-active');
    
    		setTimeout(() => {
    			activeNavItem.classList.add('swiper-pagination-bullet-active');
    		}, 10);
    	}
    }, true);
  }

  
  let iconSlider = document.querySelector('.icon_text_row');
  if(iconSlider) {
    var swiper = new Swiper(".icon_text_row", {
      loop: false,
      slidesPerView: 3.5,
      spaceBetween: 30,
      freeMode: true,
      freeModeMomentum: false,
      breakpoints: {
      575: {
        slidesPerView: 1.5,
        spaceBetween: 20
      },
      767: {
        slidesPerView: 1.7,
        spaceBetween: 20
      },
      1199: {
        slidesPerView: 2.4,
        spaceBetween: 20
      }
    }
    });
  }
  
  let collectionSlider = document.querySelector('.collection_slider_JS');
  if(collectionSlider) {
    var swiper = new Swiper(".collection_slider_JS", {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: true,
      freeModeMomentum: false,
      breakpoints: {
        575: {
          slidesPerView: 1.7,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 2.2,
        },
        991: {
          slidesPerView: 2.9,
        },
        1199: {
          slidesPerView: 3.5,
        }
      }
    });
  }
  let pdpImageSlider = document.querySelector('.pdp_about_img_row');
  if(pdpImageSlider) {
    var swiper = new Swiper(".pdp_about_img_row", {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 20,
      freeMode: true,
      freeModeMomentum: false,
      breakpoints: {
        575: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1.7,
          spaceBetween: 15,
        },
        991: {
          slidesPerView: 2.5,
        },
      }
    });
  }
  
  let customREview = document.querySelector('.custom_review_col');
  if(customREview) {
    var swiper = new Swiper(".custom_review_col", {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: false,
      freeModeMomentum: false,
      pagination: {
        el: '.custom_review_col .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        575: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 2.2,
        },
        991: {
          slidesPerView: 2.6,
        },
        1199: {
          slidesPerView: 3.5,
        }
      }
    });
  }

  let sayGuide = document.querySelector('.say-guide_col');
  if(sayGuide) {
    var swiper = new Swiper(".say-guide_col", {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: false,
      freeModeMomentum: false,
      // pagination: {
      //   el: '.say-guide_col .swiper-pagination',
      //   clickable: true,
      // },
      breakpoints: {
        575: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 2.2,
        },
        991: {
          slidesPerView: 2.6,
        },
        1199: {
          slidesPerView: 3.5,
        }
      }
    });
  }

  setInterval(function(){
    document.querySelectorAll('.mps-add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var container = btn.closest('.productSlider_inner');
        var variantSelect = container.querySelector('.mps-variant-select');
        var variantId = variantSelect.value;
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            quantity: 1,
            id: variantId
          })
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(err => { throw err; });
          }
          return response.json();
        })
        .then(function (data) {
          setTimeout(function () {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('active');
              cartDrawer.classList.remove('is-empty');
            }
  
            const drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
            if (drawerInnerEmpty) drawerInnerEmpty.style.display = 'none';
            fetch(location.href)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
  
                const newCartDrawer = doc.querySelector('#CartDrawer');
                const currentCartDrawer = document.querySelector('#CartDrawer');
                if (newCartDrawer && currentCartDrawer) {
                  currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                }
  
                const newCartIcon = doc.querySelector('#cart-icon-bubble');
                const currentCartIcon = document.querySelector('#cart-icon-bubble');
                if (newCartIcon && currentCartIcon) {
                  currentCartIcon.innerHTML = newCartIcon.innerHTML;
                }
              });
            }, 100);
          })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
        });
      });
    });
  }, 1000) 
  let question = document.querySelectorAll(".question");
  question.forEach(question => {
    question.addEventListener("click", event => {
      const active = document.querySelector(".question.active");
      if(active && active !== question ) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      question.classList.toggle("active");
      const answer = question.nextElementSibling;
      if(question.classList.contains("active")){
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = 0;
      }
    })
  })
  let recommendations_close = document.querySelector('.recommendations_close') 
  if(recommendations_close) {
    recommendations_close.addEventListener('click', function() {
      this.parentElement.classList.remove('active');
    });
  }
  let open_recommendationsSS = document.querySelector('.open_recommendationsSS') 
  if(open_recommendationsSS) {
    open_recommendationsSS.addEventListener('click', function() {
      document.querySelector('.related_shopifyPro').classList.add('active');
    });
  }
  let sticy_addCart = document.querySelector('.sticky_addCart_btn .sticy_addCart') 
  if(sticy_addCart) {
    sticy_addCart.addEventListener('click', function(){
      document.querySelector('.product-form form button.product-form__submit').click();
    })
  }
  let sticy_buyCart = document.querySelector('.sticky_addCart_btn .sticy_buyCart') 
  if(sticy_buyCart) {
    sticy_buyCart.addEventListener('click', function(){
        document.querySelector('shopify-accelerated-checkout shopify-buy-it-now-button button').click()
    })
  }
  
  // document.querySelectorAll('.quicView_mobile').forEach(function(quickViewButton) {
  //   quickViewButton.addEventListener('click', function() {
  //     var cardWrapper = quickViewButton.closest('.card-wrapper');
  //     var quickAddButton = cardWrapper.querySelector('.product-card-wrapper .card__content .quick-add button');
  //     if (quickAddButton) {
  //       quickAddButton.click();
  //     }
  //   });
  // });

  const container = document.querySelector('.cart_annousmentSlider');
  const paragraphs = container.querySelectorAll('p');
  let currentIndex = 0;
  const total = paragraphs.length;
  paragraphs.forEach(p => p.classList.remove('active'));
  if (total > 0) paragraphs[0].classList.add('active');

  setInterval(() => {
    paragraphs[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % total;
    paragraphs[currentIndex].classList.add('active');
  }, 3000);

  
  // window.addEventListener('scroll', function() {
  //   const button = document.querySelector('.sticky_buttonArrow');
  //   if (window.scrollY > 200) {
  //     button.style.display = 'flex';  // Show the button
  //   } else {
  //     button.style.display = 'none';   // Hide the button
  //   }
  // });

  // Scroll to top on button click with smooth scroll effect
  let getTop = document.querySelector('.sticky_buttonArrow')
  if (getTop) {
    getTop.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  } else {
    console.warn('.sticky_buttonArrow element not found!');
  }


  let low = 1;
  let high = 9;
  let current = high;
  let interval = 18000;

  function printNumber() {
    const parent = document.querySelector('.instok_label span');
    const targetElement = document.querySelector('.instok_label .instok_label_Text');

    if (!parent || !targetElement) {
      console.warn('Element(s) not found!');
      return;
    }
    if (current <= 5) {
      targetElement.textContent = `${current} In Stock`;
      targetElement.style.color = '#edc001';
      parent.style.backgroundColor = '#edc001';
    } else {
      targetElement.textContent = `${current} In Stock`;
      targetElement.style.color = 'green';
      parent.style.backgroundColor = 'green';
    }

    if (current === low) {
      current = high;
    } else {
      current -= 1;
    }
  }

  // setInterval(printNumber, interval);

  function printCheckedSize() {
    const checkedInput = document.querySelector('variant-selects input[type="radio"][checked]');
    const displayElement = document.querySelector('.sticky_addCart_size');

    if (!displayElement) {
      console.warn('.sticky_addCart_size element not found!');
      return;
    }

    if (checkedInput) {
      displayElement.textContent = checkedInput.value.trim();
    } else {
      displayElement.textContent = 'No size selected';
    }
  }
  setInterval(printCheckedSize, 1000);


  // function checkAndUpdateElements() {
  //   const buyNowButton = document.querySelector('.pro_buyNow_button');
  //   const productFormSubmitButton = document.querySelector('.product-form.product-form button.product-form__submit');
  //   const shopifyAppBlock = document.querySelector('.shopify-app-block');
  //   const notifyButton = document.querySelector('.notify_button');
  //   const InstockLabel = document.querySelector('.instok_label');
    
  //   if (productFormSubmitButton && productFormSubmitButton.hasAttribute('disabled')) {
  //     buyNowButton.style.display = 'none';
  //     shopifyAppBlock.style.display = 'none';
  //     InstockLabel.style.display = 'none';
  //     notifyButton.style.display = 'block';
  //   } else {
  //     buyNowButton.style.display = 'block';
  //     shopifyAppBlock.style.display = 'block';
  //     InstockLabel.style.display = 'flex';
  //     notifyButton.style.display = 'none';
  //   }
  // }
  // setInterval(checkAndUpdateElements, 100);


  document.querySelectorAll('.after_before_thumIn').forEach(item => {
      item.addEventListener('click', function() {

          let indexVal = this.dataset.index;
          let parent = this.closest('.after_before_slide');

          parent.querySelectorAll('.after_before_thumIn')
                .forEach(el => el.classList.remove('active'));

          parent.querySelectorAll('.after_before_row .after_before_trigger')
                .forEach(el => el.classList.remove('active'));

          this.classList.add('active');

          let target = parent.querySelector(`.after_before_row .after_before_trigger[data-index="${indexVal}"]`);
          if (target) target.classList.add('active');
      });
  });

});


document.querySelectorAll('.after_before_row').forEach(row => {
  row.style.setProperty('--position', '50%');
});
document.querySelectorAll('.range_slider').forEach(slider => {
  slider.value = 50;

  slider.addEventListener('input', e => {
    const row = e.target.closest('.after_before_row');
    if (!row) return;

    row.style.setProperty('--position', `${e.target.value}%`);
  });
});
